import type { HealthConfig } from '@ofmos/shared/health-config';
import type { HealthClient, HealthConfigRecord, HealthRunSummary } from '../client';
import type { Transport } from './transport';

/**
 * `HealthClient` over `/api/health-configs` (`phase-b-coach.md` D12, D13).
 *
 * As thin as `HttpReportClient`, and for the same reason: what a legal rule set IS gets
 * decided once, on the server, by `healthConfigSchema` plus the live-model checks in
 * `health/configs.ts`. A second validator here would drift from the first the day a rule
 * kind is added, and it would drift SILENTLY - both would still say yes to the rules that
 * already work.
 */
export class HttpHealthClient implements HealthClient {
  constructor(private readonly transport: Transport) {}

  async list(): Promise<readonly HealthConfigRecord[]> {
    const response = await this.transport.request<{ configs: readonly HealthConfigRecord[] }>({
      method: 'GET',
      path: '/api/health-configs',
    });
    return response.configs;
  }

  async update(id: string, config: HealthConfig): Promise<HealthConfigRecord> {
    const response = await this.transport.request<{ config: HealthConfigRecord }>({
      method: 'PATCH',
      path: `/api/health-configs/${id}`,
      body: config,
    });
    return response.config;
  }

  async run(id: string): Promise<HealthRunSummary> {
    const response = await this.transport.request<{ run: HealthRunSummary }>({
      method: 'POST',
      path: `/api/health-configs/${id}/run`,
    });
    return response.run;
  }
}
